import { render, staticRenderFns } from "./ClientGrantTypes.vue?vue&type=template&id=0fe1612e&"
import script from "./ClientGrantTypes.vue?vue&type=script&lang=js&"
export * from "./ClientGrantTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports